import NotificationIcon from './NotificationIcon';

export default NotificationIcon;
